<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import { onMount } from "svelte";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { skippedLandingPageStart } from "../../lib/helpers/steps/landing";
  import { checkLandingSession } from "../../lib/helpers/landing";
  export let currentRoute;

  onMount(() => {
    try {
      checkLandingSession();

      // The skippedLandingPageStart should only get called if the channel is actually valid
      // If the channel is invalid, the checkLandingSession will throw an error, caught here,
      // and we will navigate to the invalid channel page
      skippedLandingPageStart();
    } catch (error) {
      console.error(error);
    }
  });
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <LoadingScreen />
  </svelte:fragment>
</BaseStep>
